// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Typography_sectionInnerContainer__9kt7t{

}
table.Typography_itemContainer__zJ1Ww{
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 30px;
}
table.Typography_itemContainer__zJ1Ww * {
    box-sizing: border-box;
}
.Typography_sectionContainer__BiL7R th {
    text-align: left;
}
.Typography_sectionContainer__BiL7R tr{
    border-bottom: 1px solid black;
}
.Typography_displayColumn__BUVzP{
    width: 70%;
}
.Typography_fontColumn__\\+4Bl3{
    width: 30%;
}
.Typography_propColumn__B-Eu5,
.Typography_usageColumn__l2XX4{
    width: 15%;
}
.Typography_sectionContainer__BiL7R th,
.Typography_sectionContainer__BiL7R td{
    padding: 5px 10px;
    border-left: 1px solid black;
}
.Typography_sectionContainer__BiL7R th:first-of-type,
.Typography_sectionContainer__BiL7R td:first-of-type{
    border-left:none;
}
.Typography_commonProps__3sixJ{
    color: var(--color-darkui-accent-1);
}
.Typography_sectionContainer__BiL7R a{
    color: var(--color-blue-dark-1);
    cursor: pointer;
    text-decoration: none;
}
.Typography_sectionContainer__BiL7R a.Typography_footerLink__Tadqy {
    color: var(--color-text-dark);
    line-height: 1;
    font-size: 12px;
}
.Typography_sectionContainer__BiL7R a:hover,
.Typography_footerLink__Tadqy:hover {
    text-decoration: underline;
}
.Typography_finePrint__M\\+zba {
    font-size: 12px;
    color: var(--color-darkui-accent-2);
}
.Typography_noMargins__yXUjw{
    margin: 0;
}
.Typography_justOpenSans__leIGv {
    font-family: "Open Sans";
}
.Typography_justHelveticaNeue__9L-a2{
    font-family: "Helvetica Neue";
}
.Typography_justHelveticaNeueLight__BimaD{
    font-family:"HelveticaNeue-Light";
}
.Typography_justHelveticaNeue_Light__FHxpb{
    font-family: "Helvetica Neue Light";
}
.Typography_justHelvetica__zeEi-{
    font-family: Helvetica;
}
.Typography_justArial__eEBRf{
    font-family: Arial;
}
.Typography_justSansSerif__dslGZ{
    font-family: sans-serif;
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Typography/Typography.module.css"],"names":[],"mappings":"AAAA;;AAEA;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;;IAEI,UAAU;AACd;AACA;;IAEI,iBAAiB;IACjB,4BAA4B;AAChC;AACA;;IAEI,gBAAgB;AACpB;AACA;IACI,mCAAmC;AACvC;AACA;IACI,+BAA+B;IAC/B,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,6BAA6B;IAC7B,cAAc;IACd,eAAe;AACnB;AACA;;IAEI,0BAA0B;AAC9B;AACA;IACI,eAAe;IACf,mCAAmC;AACvC;AACA;IACI,SAAS;AACb;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,6BAA6B;AACjC;AACA;IACI,iCAAiC;AACrC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,uBAAuB;AAC3B","sourcesContent":[".sectionInnerContainer{\n\n}\ntable.itemContainer{\n    width: 100%;\n    box-sizing: border-box;\n    margin-bottom: 30px;\n}\ntable.itemContainer * {\n    box-sizing: border-box;\n}\n.sectionContainer th {\n    text-align: left;\n}\n.sectionContainer tr{\n    border-bottom: 1px solid black;\n}\n.displayColumn{\n    width: 70%;\n}\n.fontColumn{\n    width: 30%;\n}\n.propColumn,\n.usageColumn{\n    width: 15%;\n}\n.sectionContainer th,\n.sectionContainer td{\n    padding: 5px 10px;\n    border-left: 1px solid black;\n}\n.sectionContainer th:first-of-type,\n.sectionContainer td:first-of-type{\n    border-left:none;\n}\n.commonProps{\n    color: var(--color-darkui-accent-1);\n}\n.sectionContainer a{\n    color: var(--color-blue-dark-1);\n    cursor: pointer;\n    text-decoration: none;\n}\n.sectionContainer a.footerLink {\n    color: var(--color-text-dark);\n    line-height: 1;\n    font-size: 12px;\n}\n.sectionContainer a:hover,\n.footerLink:hover {\n    text-decoration: underline;\n}\n.finePrint {\n    font-size: 12px;\n    color: var(--color-darkui-accent-2);\n}\n.noMargins{\n    margin: 0;\n}\n.justOpenSans {\n    font-family: \"Open Sans\";\n}\n.justHelveticaNeue{\n    font-family: \"Helvetica Neue\";\n}\n.justHelveticaNeueLight{\n    font-family:\"HelveticaNeue-Light\";\n}\n.justHelveticaNeue_Light{\n    font-family: \"Helvetica Neue Light\";\n}\n.justHelvetica{\n    font-family: Helvetica;\n}\n.justArial{\n    font-family: Arial;\n}\n.justSansSerif{\n    font-family: sans-serif;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sectionInnerContainer": `Typography_sectionInnerContainer__9kt7t`,
	"itemContainer": `Typography_itemContainer__zJ1Ww`,
	"sectionContainer": `Typography_sectionContainer__BiL7R`,
	"displayColumn": `Typography_displayColumn__BUVzP`,
	"fontColumn": `Typography_fontColumn__+4Bl3`,
	"propColumn": `Typography_propColumn__B-Eu5`,
	"usageColumn": `Typography_usageColumn__l2XX4`,
	"commonProps": `Typography_commonProps__3sixJ`,
	"footerLink": `Typography_footerLink__Tadqy`,
	"finePrint": `Typography_finePrint__M+zba`,
	"noMargins": `Typography_noMargins__yXUjw`,
	"justOpenSans": `Typography_justOpenSans__leIGv`,
	"justHelveticaNeue": `Typography_justHelveticaNeue__9L-a2`,
	"justHelveticaNeueLight": `Typography_justHelveticaNeueLight__BimaD`,
	"justHelveticaNeue_Light": `Typography_justHelveticaNeue_Light__FHxpb`,
	"justHelvetica": `Typography_justHelvetica__zeEi-`,
	"justArial": `Typography_justArial__eEBRf`,
	"justSansSerif": `Typography_justSansSerif__dslGZ`
};
export default ___CSS_LOADER_EXPORT___;
